import React, { useCallback } from "react";
import i18n from "../../i18n";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { cn } from "../../utils/cn";

interface SwitchLanguageCardProps {
  styles?: string;
}

const SwitchLanguageCard = ({ styles }: SwitchLanguageCardProps) => {
  const { t } = useTranslation();

  const changeLanguage = useCallback(
    debounce(() => {
      const currentLanguage = localStorage.getItem("i18nextLng");
      if (currentLanguage === "en") {
        i18n.changeLanguage("ar");
      } else {
        i18n.changeLanguage("en");
      }
    }, 100),
    []
  );

  return (
    <div
      onClick={changeLanguage}
      className={cn(
        "flex items-center md:gap-1 border-2 border-purple-primary rounded-md px-[1px] sm:px-0.5 md:px-3 py-[1px] sm:py-0.5 cursor-pointer",
        styles
      )}
    >
      <Languages className="w-3 sm:w-4  hidden sm:block" />
      <p className="text-xs md:text-sm font-semibold ">{t("switchLng")}</p>
    </div>
  );
};

export default React.memo(SwitchLanguageCard);
